import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ConnectionResolver } from '@core/api/signalr.connectionresolver';
import { BaseComponent } from '@core/base/base.component';
import { ApplicationInsightsService } from '@core/services/application-insights.service';
import { LocalStorageService } from '@core/services/local-storage.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from './core/services/auth.service';

@Component({
   selector: 'app-root',
   templateUrl: './app.component.html',
   standalone: true,
   changeDetection: ChangeDetectionStrategy.Eager,
   imports: [RouterOutlet],
})
export class AppComponent extends BaseComponent implements OnInit {
   private authService = inject(AuthService);
   private connectionResolver = inject(ConnectionResolver);
   private applicationInsightsService = inject(ApplicationInsightsService);
   private translate = inject(TranslateService);
   private localStorageService = inject(LocalStorageService);

   initApp() {
      let langCode = this.localStorageService.getLanguage() || 'pt-BR';
      this.translate.setFallbackLang(langCode);
      this.translate.use(langCode);
      this.applicationInsightsService.initialize();
   }

   ngOnInit(): void {
      this.initApp();

      this.authService.authorizationTokenObservable
         .pipe(this.takeUntilDestroy())
         .subscribe((val: any) => {
            if (val) {
               setTimeout(() => {
                  this.connectionResolver.resolve();
               }, 100);
            }
         });

      this.initConnection();
   }

   initConnection() {
      try {
         setTimeout(() => {
            this.connectionResolver.resolve();
         }, 500);
      } catch {}
   }
}
